export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/partner/state.js